var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWineBottle = function SvgWineBottle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "496pt",
    viewBox: "-88 0 496 496",
    width: "496pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m96 140.078125v-20.078125h-48v20.078125c-28 9.921875-48 36.5625-48 67.921875v272c0 8.800781 7.121094 16 16 16h112c8.800781 0 16-7.199219 16-16v-272c0-31.359375-20.078125-58-48-67.921875zm0 0",
    fill: "#656d78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256 495.992188c-4.425781 0-8-3.578126-8-8v-95.929688c0-4.421875 3.574219-8 8-8s8 3.578125 8 8v95.929688c0 4.421874-3.574219 8-8 8zm0 0",
    fill: "#ccd1d9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m48 0h48v39.921875h-48zm0 0",
    fill: "#ed5565"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m48 39.921875h48v80.078125h-48zm0 0",
    fill: "#da4453"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m303.921875 224.078125 16 103.921875h-127.921875l16-103.921875zm0 0",
    fill: "#e6e9ed"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m303.921875 224.078125h-16.019531l16 103.921875h16.019531zm0 0",
    fill: "#ccd1d9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m319.921875 328h.078125c0 35.359375-28.640625 64-64 64s-63.921875-28.558594-64-63.921875v-.078125zm0 0",
    fill: "#ed5565"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m319.921875 328h-15.9375c0 32.640625-24.433594 59.503906-55.992187 63.449219 2.625.328125 5.289062.550781 8.007812.550781 35.359375 0 64-28.640625 64-64zm0 0",
    fill: "#da4453"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m24 415.984375v-151.96875h96v151.96875zm0 0",
    fill: "#ed5565"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m96 140.078125v-20.078125h-24.023438v28.089844c27.917969 9.917968 48 36.558594 48 67.917968v31.992188h.023438v184h-.023438v48c0 8.800781-7.199218 16-16 16h24.023438c8.800781 0 16-7.199219 16-16v-272c0-31.359375-20.078125-58-48-67.921875zm0 0",
    fill: "#434a54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m71.976562 39.921875h24.023438v80.078125h-24.023438zm0 0",
    fill: "#d3374e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#da4453"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.976562 0h24.023438v39.921875h-24.023438zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 307.921875c0 6.636719-5.359375 12-12 12s-12-5.363281-12-12c0-6.5625 5.359375-12 12-12s12 5.4375 12 12zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 316.671875c6.640625 0 12 5.441406 12 12 0 6.640625-5.359375 12-12 12s-12-5.359375-12-12c0-6.558594 5.359375-12 12-12zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 307.921875c0-6.5625 5.359375-12 12-12s12 5.4375 12 12c0 6.636719-5.359375 12-12 12s-12-5.363281-12-12zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.984375 367.960938h-48.015625c-4.425781 0-8-3.578126-8-8 0-4.425782 3.574219-8 8-8h48.015625c4.421875 0 8 3.574218 8 8 0 4.421874-3.578125 8-8 8zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.96875 391.96875h-15.984375c-4.425781 0-8-3.578125-8-8 0-4.425781 3.574219-8 8-8h15.984375c4.421875 0 8 3.574219 8 8 0 4.421875-3.578125 8-8 8zm0 0"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m303.945312 495.992188h-95.96875c-4.425781 0-8-3.578126-8-8 0-4.425782 3.574219-8 8-8h95.96875c4.421876 0 8 3.574218 8 8 0 4.421874-3.578124 8-8 8zm0 0",
    fill: "#e6e9ed"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWineBottle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wineBottle.f06ea33e.svg";
export { ForwardRef as ReactComponent };